import { render, staticRenderFns } from "./ProjectShowDocumentsTab.vue?vue&type=template&id=ae8b9290"
import script from "./ProjectShowDocumentsTab.vue?vue&type=script&lang=ts"
export * from "./ProjectShowDocumentsTab.vue?vue&type=script&lang=ts"
import style0 from "./ProjectShowDocumentsTab.vue?vue&type=style&index=0&id=ae8b9290&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports